<template>
  <KfDesktop>
    <template #appGrid>
      <GroupDesktop/>
    </template>
  </KfDesktop>
</template>
<script>
import GroupDesktop from "@/views/GroupDesktop.vue";

export default {
  name: 'Desktop',
  components: {GroupDesktop}
};
</script>

<style lang="less" scoped>

</style>
